<!---环境归一：注册页面-->
<template>
  <div class="register-page">
    <div class="page-title">
      <span>欢迎注册开发者账号</span>
      <div class="title-sub">
        <span>已有账号？</span><span class="text-warning pointer" @click="goLogin">请登录</span>
      </div>
    </div>
    <div class="steps-box">
      <hll-steps :steps-list="['验证手机', '完善信息', '注册成功']" :step-index="curStep"></hll-steps>
    </div>
    <div class="from-box large-form" v-show="curStep === 0">
      <el-form ref="registerForm1"
               :model="editInfo"
               label-width="0">
        <el-form-item label="" prop="reg_mobile" :rules="rules.reg_mobile">
          <el-input v-model="editInfo.reg_mobile" maxlength="11" clearable placeholder="请输入手机号">
            <i slot="prefix" class="input-icon input-icon-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="code" :rules="rules.code" class="input-code-item">
          <el-input v-model="editInfo.code" maxlength="4" clearable placeholder="图片验证码">
            <i slot="prefix" class="input-icon input-icon-shield"></i>
          </el-input>
          <div class="input-code-box">
            <img :src="codeImg" class="pointer" @click="getImgCode" v-if="codeImg"/>
          </div>
        </el-form-item>
        <el-form-item label="" prop="sms_code" :rules="rules.code" class="input-code-item">
          <el-input v-model="editInfo.sms_code" maxlength="4" clearable placeholder="请输入验证码">
            <i slot="prefix" class="input-icon input-icon-password"></i>
          </el-input>
          <div class="input-code-box text-warning pointer" @click="getSmsCode">
            {{ smsTimer === 0 ? '获取验证码' : `${smsTimer}s后重试` }}
          </div>
        </el-form-item>
        <el-form-item label="" prop="is_agree" class="agree-box-item" :rules="rules.is_agree">
          <div class="agree-box">
            <span @click="agreeClick">
              <span :class="['check_box', {'on': editInfo.is_agree}]"></span>
              <span class="ml-xxl">我已阅读并同意</span>
            </span>
            <span class="text-warning" @click="goAgreementService">《开放平台开发者注册协议》</span>
          </div>
        </el-form-item>
      </el-form>
      <el-button class="submit-btn" @click="nextStepClick">下一步</el-button>
    </div>
    <div class="from-box large-form small-space star-hide" v-show="curStep === 1">
      <el-form ref="registerForm2"
               :model="editInfo"
               label-position="left"
               label-width="100px">
        <el-form-item label="用户名" prop="account" :rules="rules.account">
          <el-input v-model="editInfo.account" maxlength="30" clearable placeholder="请自定义用户名，不可重复"></el-input>
        </el-form-item>
        <input type="password" class="hide-input">
        <el-form-item label="设置密码" prop="password" :rules="rules.password">
          <el-input v-model="editInfo.password" type="password" maxlength="16" clearable
                    placeholder="8~16位数字和字母组成，字母区分大小写"
                    autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password_confirmation" :rules="rules.password_confirmation">
          <el-input v-model="editInfo.password_confirmation" type="password" maxlength="16" clearable
                    placeholder="请确认密码" autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="设置邮箱" prop="email" :rules="rules.email">
          <el-input v-model="editInfo.email" clearable maxlength="50" placeholder="请设置邮箱"></el-input>
        </el-form-item>
        <el-form-item label="图形验证码" prop="captcha_code" :rules="rules.code" class="input-code-item">
          <el-input v-model="editInfo.captcha_code" maxlength="4" clearable placeholder="图片验证码">
          </el-input>
          <div class="input-code-box">
            <img :src="codeImg" class="pointer" @click="getImgCode" v-if="codeImg"/>
          </div>
        </el-form-item>
        <el-form-item label="邮箱验证码" prop="email_code" :rules="rules.code" class="input-code-item">
          <el-input v-model="editInfo.email_code" maxlength="4" clearable placeholder="请输入邮箱验证码"></el-input>
          <div class="input-code-box text-warning pointer" @click="getEmailCode">
            {{ smsTimer === 0 ? '获取验证码' : `${smsTimer}s后重试` }}
          </div>
        </el-form-item>
      </el-form>
      <el-button class="submit-btn" @click="nextStepClick">下一步</el-button>
    </div>
    <div class="from-box text-center" v-show="curStep === 2">
      <div class="result-box text-left">
        <div class="result-titlte">账号注册成功</div>
        <div class="result-tips">请牢记您的密码！</div>
      </div>
      <el-button class="submit-btn disabled">{{ backTimer }}s后返回首页</el-button>
    </div>
    <el-dialog
        title="货拉拉开放平台-开发者注册协议"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :center="true"
        @close="handleClose"
        :class="{ 'change' : animation }">
      <service></service>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-button" @click="handleSuccess">同意并继续</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import md5 from 'md5'
import HllSteps from '../common/hll-steps'
import service from '../agreement/service'
import {sandboxRequest} from "../../axios/sandboxRequest";
import {loginPath} from "../../assets/js/common";

export default {
  name: 'enroll',
  data() {
    // 验证手机号是否已被注册
    let phoneCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (value && !this.$config.regCommon.phone.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        sandboxRequest.checkMobile(this.editInfo.reg_mobile)
            .then(res => repeatCheckHandler('该手机号已注册', '手机号验证失败', res, callback))
            .catch(e => callback(e.msg));
      }
    }

    // 验证账号是否已被注册
    let accountCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名'));
      } else if (!this.$config.regCommon.account.test(value)) {
        callback(new Error('用户名仅支持汉字、数字和字母'));
      } else {
        sandboxRequest.checkAccount(this.editInfo.reg_mobile, this.editInfo.account)
            .then(res => repeatCheckHandler('该用户名已存在', '用户名验证失败', res, callback))
            .catch(e => callback(e.msg))
      }
    }

    // 验证邮箱是否已被注册
    let emailCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入邮箱'));
      } else if (value && !this.$config.regCommon.email.test(value)) {
        callback(new Error('请输入正确的邮箱地址，格式为 xxx@xxxx.xx'));
      } else {
        sandboxRequest.checkEmail(this.editInfo.reg_mobile, this.editInfo.email)
            .then(res => repeatCheckHandler('该邮箱已注册', '邮箱验证失败', res, callback))
            .catch(e => callback(e.msg));
      }
    }

    let repeatCheckHandler = (repeatMsg, failMsg, res, callback) => {
      console.log(res)
      if (res.ret === 0) { // 操作成功
        res.data ? callback(new Error(repeatMsg)) : callback();
      } else {
        callback(new Error(failMsg));
      }
    }

    let agreeCheck = (rule, value, callback) => {
      value ? callback() : callback(new Error('请阅读并同意'));
    }

    let passwordCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value && !this.$config.regCommon.password.test(value)) {
        callback(new Error('密码长度为8~16位，需包含数字和字母，字母区分大小写'));
      } else {
        callback();
        // 密码验证通过 判断二次确认的密码是否存在 若存在 则触发校验
        if (this.editInfo.password_confirmation) {
          this.$refs.registerForm2.validateField('password_confirmation')
        }
      }
    }
    let password2Check = (rule, value, callback) => {
      if (!this.editInfo.password) {
        return callback();
      }
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (this.editInfo.password !== value) {
        callback(new Error('两次输入的密码不一致，请检查'));
      } else {
        callback();
      }
    }

    return {
      curStep: 0,
      codeImg: '',
      codeKey: '',
      smsTimer: 0,
      backTimer: 5,
      editInfo: {
        reg_mobile: '',
        code: '',
        sms_code: '',
        is_agree: '',
        account: '',
        password: '',
        password_confirmation: '',
        email: '',
        email_code: '',
        captcha_code: ''
      },
      rules: {
        reg_mobile: [
          {validator: phoneCheck, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        is_agree: [
          {validator: agreeCheck, trigger: 'blur'}
        ],
        account: [
          {validator: accountCheck, trigger: 'blur'}
        ],
        password: [
          {validator: passwordCheck, trigger: 'blur'}
        ],
        password_confirmation: [
          {validator: password2Check, trigger: 'blur'}
        ],
        email: [
          {validator: emailCheck, trigger: 'blur'}
        ],
      },
      dialogVisible: true,
      animation: false
    }


  },
  components: {
    HllSteps,
    service
  },
  mounted() {
    this.getImgCode()
  },
  methods: {
    ...mapActions(['getUserInfo']),
    goLogin() {
      this.$router.push({path: loginPath()})
    },
    goAgreementService() {
      this.dialogVisible = true;
    },
    // 获取图片验证码
    getImgCode() {
      this.$axios.get("/ajax/common/interface/captcha/get", {
        params: {
          type: 1 // 1为注册; 2为登陆; 3为忘记密码
        }
      }).then(res => {
        this.codeImg = res.data.data.img;
        this.codeKey = res.data.data.key;
      });
    },
    // 验证图片验证码
    checkImgCode() {
      return new Promise((resolve, reject) => {
        this.$axios.post("/ajax/common/interface/captcha/check", {
          code: this.editInfo.code,
          key: this.codeKey,
          type: 1
        }).then(res => {
          resolve()
        }).catch(e => {
          if (e.type === 1) {
            this.getImgCode();
            reject()
          } else if (e.type === 2) {
            reject()
          }
        });
      })
    },
    // 获取短信验证码
    getSmsCode() {
      if (this.isLoading || this.smsTimer !== 0) {
        return
      }
      let checkNum = 0;
      let checkError = ''
      this.$refs.registerForm1.validateField(['reg_mobile', 'code'], error => {
        checkNum++
        checkError += error
        if (checkNum === 2 && !checkError) {
          this.showCommonLoading()
          this.$axios.post("/ajax/common/interface/mobile/code", {
            reg_mobile: this.editInfo.reg_mobile,
            code: this.editInfo.code,
            key: this.codeKey,
            type: 1
          }).then(res => {
            this.hideCommonLoading();
            if (res.data.ret === 0) {
              this.$message.success('短信验证码发送成功');
              this.setSmsTimer();
            }
          }).catch(e => {
            this.hideCommonLoading();
          });
        }
      })
    },
    // 验证短信验证码
    checkSmsCode() {
      return new Promise((resolve, reject) => {
        this.$axios.post("/ajax/common/interface/mobile/code/check", {
          reg_mobile: this.editInfo.reg_mobile,
          sms_code: this.editInfo.sms_code,
          type: 1
        }).then(res => {
          resolve();
        }).catch(e => {
          reject();
        });
      })
    },
    // 设置短信验证码获取倒计时
    setSmsTimer() {
      this.smsTimer = 60
      let timerItem = setInterval(() => {
        if (this.smsTimer === 0) {
          clearInterval(timerItem)
        } else {
          this.smsTimer--
        }
      }, 1000)
    },
    agreeClick() {
      this.editInfo.is_agree = !this.editInfo.is_agree;
      this.$refs.registerForm1.validateField('is_agree')
    },

    // 获取邮箱验证码
    getEmailCode() {
      if (this.isLoading || this.smsTimer !== 0) {
        return
      }
      this.$refs.registerForm2.validateField('email', error => {
        if (!error) {
          this.showCommonLoading()
          this.$axios.post("/ajax/common/interface/email/code", {
            code: this.editInfo.captcha_code,
            key: this.codeKey,
            email: this.editInfo.email,
            type: 1,
          }).then(res => {
            this.hideCommonLoading();
            if (res.data.ret === 0) {
              this.$message.success('短信验证码发送成功');
              this.setSmsTimer();
            }
          }).catch(e => {
            this.getImgCode()
            this.hideCommonLoading();
          });
        }
      })
    },
    // 发起注册请求
    applyRegister() {

      let form = {
        account: this.editInfo.account,
        reg_mobile: this.editInfo.reg_mobile,
        email: this.editInfo.email,
        password: md5(this.editInfo.password),
        password_confirmation: md5(this.editInfo.password_confirmation),
        email_code: this.editInfo.email_code,
        code: this.editInfo.captcha_code,
        key: this.codeKey
      };
      return new Promise((resolve, reject) => {
        sandboxRequest.submitRegister(form).then(res => {
          this.hideCommonLoading();
          if (res.ret === 0) {
            resolve();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(e => {
          this.hideCommonLoading();
          this.getImgCode();
          reject();
        });
      });
    },
    // 下一步
    nextStepClick() {
      if (this.isLoading) {
        return
      }
      if (this.curStep === 0) {
        let checkNum = 0;
        let checkError = ''
        this.$refs.registerForm1.validateField(['reg_mobile', 'sms_code', 'is_agree'], error => {
          checkNum++
          checkError += error
          if (checkNum === 3 && !checkError) {
            this.$refs.registerForm1 && this.$refs.registerForm1.clearValidate()
            this.getImgCode()
            this.showCommonLoading()
            this.checkSmsCode().then(() => {
              this.hideCommonLoading();
              this.smsTimer = 0;
              this.curStep++;
            }).catch(() => {
              this.hideCommonLoading()
            })
          }
        })
      } else if (this.curStep === 1) {
        this.$refs.registerForm2.validate(valid => {
          if (valid) {
            this.showCommonLoading()
            this.applyRegister().then(() => {
              this.hideCommonLoading()
              this.curStep++
              // 倒计时返回首页
              this.backTimer = 5
              let backTimerItem = setInterval(() => {
                if (this.backTimer === 1) {
                  clearInterval(backTimerItem)
                  this.goLogin();
                } else {
                  this.backTimer--
                }
              }, 1000)
            }).catch(() => {
              this.hideCommonLoading()
            })
          }
        })
      }
    },
    handleClose() {
      this.animation = true;
      this.$refs.registerForm1.validateField('is_agree');
      setTimeout(() => {
        this.animation = false;
      }, 600);
    },
    handleSuccess() {
      this.editInfo.is_agree = true;
      this.animation = true;
      setTimeout(() => {
        this.animation = false;
        this.dialogVisible = false;
      }, 300);
    }
  }
}
</script>

<style lang="scss">
.register-page {
  .agree-box-item {
    margin-bottom: 0;
    margin-top: -12px;

    .el-form-item__error {
      top: 7px;
    }
  }

  .check_box {
    position: relative;
    top: 1px;
  }
}
</style>
<style lang="scss" scoped>
.register-page {
  width: 724px;
  margin: 55px auto;

  .page-title {
    width: 100%;
    height: 32px;
    line-height: 32px;
    font-size: 24px;
    color: #212121;
    text-align: center;
    position: relative;
  }

  .title-sub {
    position: absolute;
    right: 6px;
    top: 8px;
    font-size: 12px;
    color: #ccc;
  }

  .steps-box {
    width: 100%;
    margin-top: 68px;
  }

  .from-box {
    width: 430px;
    margin: 69px auto;
  }

  .agree-box {
    display: inline-block;
    font-size: 12px;
    line-height: 16px;
    color: #424456;
    margin-bottom: 20px;
    cursor: pointer;

    span {
      vertical-align: top;
    }
  }

  .submit-btn {
    width: 100%;
    height: 48px;
    background: #F16222;
    font-size: 18px;
    color: #fff;
    border: none;
    font-weight: normal;

    &.disabled {
      background: rgba(241, 98, 34, .35);
    }
  }

  .result-box {
    display: inline-block;
    width: auto;
    height: 80px;
    background: url("../../assets/img/account/icon_success.png") no-repeat left center;
    background-size: 80px 80px;
    padding-left: 134px;
    margin: 55px auto 110px;
    box-sizing: border-box;

    .result-titlte {
      color: #424456;
      font-size: 22px;
      line-height: 30px;
      padding-top: 10px;
      margin-bottom: 13px;
    }

    .result-tips {
      color: #919191;
      font-size: 16px;
      line-height: 22px;
    }
  }
}

/deep/ .el-dialog {
  height: 66.6%;

  .el-dialog__body {
    height: calc(100% - 165px);
    overflow-y: scroll;
    padding: 15px 24px;
  }

  .el-dialog__footer {
    height: 64px;
    padding: 12px;

    .dialog-button {
      width: 350px;
      color: #FFFFFF;
      background: #F16622;
      border-radius: 2px;
      border: 1px solid rgba(224, 224, 224, 1);
    }
  }
}

.change {
  animation: perspective 0.4s ease-out;
}

@keyframes perspective {
  from {
    transform: perspective(0px) rotateX(0deg);
    opacity: 1;
  }
  to {
    transform: perspective(630px) rotateX(-90deg);
    opacity: .5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/enroll.vue